<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh3"><a id="page_xxvi"></a><a id="page_xxvii"></a><span class="bold">List of Abbreviations</span></h2>
<table>
<tbody><tr>
<td>
<p class="ttext"><em class="italic">CDS</em></p>
</td>
<td>
<p class="ttext">J. Bain (ed.), <em class="italic">Calendar of Documents relating to Scotland</em>, Vol. IV, 1357–1509, Edinburgh, 1881–8</p>
</td>
</tr>
<tr>
<td>
<p class="ttext">De Fonblanque</p>
</td>
<td>
<p class="ttext">E.B. De Fonblanque, <em class="italic">Annals of the House of Percy: From the Conquest to the opening of the nineteenth century</em>, London, R. Clay &amp; Sons, 1887, Vol. 1</p>
</td>
</tr>
<tr>
<td>
<p class="ttext">Froissart</p>
</td>
<td>
<p class="ttext">Jean Froissart, <em class="italic">Chronicles of England, France etc.</em>, trans. Lord Berners, ed. G.C. Macaulay, London, Macmillan &amp; Co., 1924</p>
</td>
</tr>
<tr>
<td>
<p class="ttext">Hardyng</p>
</td>
<td>
<p class="ttext">J. Hardyng, <em class="italic">The Chronicle of John Hardyng</em>, ed. F.C. and J. Rivington, England, 1812</p>
</td>
</tr>
<tr>
<td>
<p class="ttext">Ridpath</p>
</td>
<td>
<p class="ttext">G. Ridpath, <em class="italic">The Border History of England and Scotland</em>, Edinburgh, Mercat Press, 1979</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><em class="italic">Scotichronicon</em></p>
</td>
<td>
<p class="ttext">Walter Bower, <em class="italic">Scotichronicon</em>, ed. D.E.R. Watt, Edinburgh, John Donald, 2012, Vol. 7</p>
</td>
</tr>
<tr>
<td>
<p class="ttext">Usk</p>
</td>
<td>
<p class="ttext"><em class="italic">Chronicles of Adam of Usk 1377–1421</em>, trans. C. Given-Wilson, Oxford, Oxford Medieval Texts, 1997</p>
</td>
</tr>
<tr>
<td>
<p class="ttext">Walsingham</p>
</td>
<td>
<p class="ttext">Thomas Walsingham, <em class="italic">Historia Anglicana</em>, ed. H.T. Riley, Rolls Series, Cambridge Library, 2015</p>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Abbreviations.vue?5d9400f8